export default class {
  constructor (data) {
    this.id = ~~data?.id
    this.name = data?.name ?? ''
    this.activeOpt = data?.active_opt ?? ''
    this.optA = data?.opt_a ?? ''
    this.optAType = data?.opt_a_dest_type ?? ''
    this.optATarget = data?.opt_a_target ?? ''
    this.optB = data?.opt_b ?? ''
    this.optBType = data?.opt_b_dest_type ?? ''
    this.optBTarget = data?.opt_b_target ?? ''
  }

  get isValid () {
    return this.id > 0 &&
      this.name.length > 0 &&
      this.activeOpt.length > 0 &&
      this.optA.length > 0 &&
      this.optB.length > 0
  }

  get isActiveA () { return this.activeOpt === this.optA }

  get isActiveB () { return this.activeOpt === this.optB }

  get activeOptName () {
    return this.isActiveA
      ? this.optAName
      : this.optBName
  }

  get optAName () { return `${this.optAType} ${this.optATarget}` }

  get optBName () { return `${this.optBType} ${this.optBTarget}` }

  toggle () {
    this.activeOpt = this.isActiveA
      ? this.optB
      : this.optA
  }
}
